import { render, staticRenderFns } from "./PersonalisedHelp.vue?vue&type=template&id=0c94ea98"
import script from "./PersonalisedHelp.vue?vue&type=script&lang=js"
export * from "./PersonalisedHelp.vue?vue&type=script&lang=js"
import style0 from "./PersonalisedHelp.vue?vue&type=style&index=0&id=0c94ea98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports